import React from 'react';
import { EligibilityStatusEditTemplate } from 'themes/application/eligibility-status/pages';
import { observer } from 'mobx-react';
import { EligibilityStatusEditViewStore } from 'application/eligibility-status/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new EligibilityStatusEditViewStore(rootStore), 'eligibilityStatusEditViewStore')
@observer
class EligibilityStatusEdit extends React.Component {
    render() {
        return <EligibilityStatusEditTemplate {...this.props} />
    }
}

export default EligibilityStatusEdit;
